"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCell = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const index_1 = require("../index");
const TagCell = ({ columnId, tags, ...cellProps }) => {
    return (react_1.default.createElement(TableCell_1.default, { ...cellProps }, tags?.map((tag, idx) => (react_1.default.createElement(index_1.Tag, { key: `tag-cell-${idx}`, ...tag })))));
};
exports.TagCell = TagCell;
exports.default = exports.TagCell;
